/**
 * 弹出框模块
 */

define(function(require, exports, module) {

    var Layer = require('c-layer');
    var Mask = require('c-mask');


    var templateList = [
        '<div class="widget-poplayer {{popup-type}}">',
            '<span class="widget-poplayer-close" data-id="close">×</span>',
            '<div class="widget-poplayer-content panel">',
                '<div class="content-wrap content">',
                    '<div class="content-bd">', 
                         '{{content}}',
                         
                    '</div>',
                    '<div class="content-ft">',
                        '<button class="confirm-btn normal-btn" data-id="confirm">{{confirmbtn}}</button>',
                        '<button class="cancle-btn" data-id="close">{{cancleBtn}}</button>',
                    '</div>',
                '</div>',
            '</div>',
        '</div>'
    ];


    var PopLayer = Layer.extend({

        defaults: {
            template : templateList.join(''),
            content: '',
            type:'alert' ,//confirm  toast
            confirmBtn: '确定',
            cancleBtn: '取消',
            zIndex: 99,
            hideWhenTap: 1
        },

        initialize: function() {
            var self = this;

            self.mask = new Mask({
                hideWhenTap: self.get("hideWhenTap"),
                css: {
                    zIndex: self.get("zIndex"),
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    background: '#000',
                    opacity: '0.8',
                    top: 0,
                    left: 0
                }
            });
            self.Parent(self, arguments);
        },

        create: function() {
            $('html').addClass('noscroll');
            var self = this;
            let content = this.get('content');
            let template = this.get('template');
            let confirmbtn = this.get('confirmBtn');
            let cancleBtn = this.get('cancleBtn');
            if(confirmbtn == '确定'){
                confirmbtn = UpAct.lang.template(confirmbtn);
            }
            if(cancleBtn == '取消'){
                cancleBtn = UpAct.lang.template(cancleBtn);

            }
            let type = this.get('type');
            template = template.replace('{{content}}', content);
            template = template.replace('{{confirmbtn}}',confirmbtn);
            template = template.replace('{{cancleBtn}}',cancleBtn);
            template = template.replace('{{popup-type}}',self.get('type'));
            
            self.set('template', template);

            self.Parent.apply(self, arguments);
            if(type == 'alert'){
                self.get('el').find('.cancle-btn').remove();
            }else if(type == 'toast'){
                self.get('el').find('.content-ft').html('');
            }
            self.mask.create();

            self.fixPostion();
            self.bindEvent();
        },

        fixPostion: function() {
            var el = this.get('el');
            
            el.css({
                'margin-left': '-' + el.width() / 2 + 'px',
                'margin-top': '-' + el.height() / 2 + 'px',
            });
        },
        bindEvent: function() {
            var self = this;
            var el = this.get('el');

            el.on('click', '[data-id=close]', function() {
                self.emit('close');
                self.destroy();
                self.mask.destroy();
            });
            el.on('click', '[data-id=confirm]' , function (e) {
                self.mask.destroy();
                self.destroy();
                self.emit('confirm' , e);
            });

            //$.smartScroll(el, '.popup-scroll');

            // el.on('touchstart',function(e){
            //     $.smartScroll(el, '.popup-scroll');
            // })
            let top = el.css("marginTop").replace("px","")*1;
            
            /*
            el.on("focus",'input,select,textarea',function(){
                let scrollTop = $(window).scrollTop();
                //$(el).css({"position":"absolute"});
                
                //window.scrollTo(0,0);
                //$(document).css({height:"100%",overflow:"hidden"})
                $(el).css({"top":"0","marginTop":"1.25rem"});
            }).on("blur",'input,select,textarea',function(){
                //$(el).css({"position":"fixed"});
                $(el).css({"top":"50%","marginTop":top+"px"});
                //alert("asdf");
                //$(document).css({height:"auto",overflow:"auto"})
                //$(el).css({"position":"fixed","marginTop":top+"px"});
            });
            */

            self.mask.on('destroy', function() {
                
                $('html').removeClass('noscroll');
                el.remove();
            });
        }

    });

    UpAct.PopLayer = PopLayer;

    module.exports = PopLayer;
});



// WEBPACK FOOTER //
// ./js/lib/poplayer/index.js